/*!
 * Black Dashboard PRO React - v1.0.0
 * Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)
 * Coded by Creative Tim
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import React, { Component } from 'react';
import { Button, Card, Col } from 'reactstrap';
import NotificationAlert from 'react-notification-alert';
import getRoles from '../../Auth/getRoles';

import DropshipForm from '../DropshipForm/DropshipForm';
import DispatchOrderTable from '../Dispatch/DispatchOrderTable';
import MerchantOrderTable from '../Merchant/MerchantOrderTable';
import BillChat from '../Support/BillChat';
import CustomerPlanBanner from '../Merchant/CustomerPlanBanner';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.notificationAlertRef = React.createRef();
    this.state = {
      showForm: false,
      showForm2: false,
      street: '',
      city: '',
      state: '',
      query: '',
      // activeTab: "pending",
      activeTab: 'inProgress',
      errorSubmit: {},
      errorDistance: {},
      savedDraftEdit: null,
      role: '99999',
      expandedItems: { pending: {}, inProgress: {}, completed: {}, saved: {}, ready: {}, progressing: {}, merging: {}, driverList: {} }
    };
  }

  componentDidMount() {
    getRoles().then(val => {
      if (val === 'error') {
        this.setState({ role: this.props.role || this.state.role });
      } else {
        this.setState({ role: val[0] });
      }
    });
  }

  handleCancel = () => {
    this.setState({ showForm: false });
  };

  toggle = () => {
    this.setState(state => ({
      showForm: !state.showForm,
      savedDraftEdit: state.showForm ? null : state.savedDraftEdit
    }));
  };

  openSavedDraftEditor = savedDraftEdit => {
    this.setState({
      showForm: true,
      showForm2: false,
      savedDraftEdit
    });
  };

  externalToggle = (showForm, showForm2) => {
    this.setState({
      showForm: showForm,
      showForm2: showForm2
    });
  };

  externalErrorSubmit = error => {
    this.setState({
      errorSubmit: error
    });
  };

  externalErrorDistance = error => {
    this.setState({
      errorDistance: error
    });
  };

  handleClick = e => {
    this.setState({ activeTab: e.target.name });
  };

  notify = (place, errorType, customMessage) => {
    var type = 'info';
    var options = {
      place: place,
      message: (
        <div>
          <div>{errorType === null ? customMessage : errorType === 'distance' ? this.state.errorDistance.errorMessage : this.state.errorSubmit.errorMessage}</div>
        </div>
      ),
      type: type,
      icon: 'tim-icons icon-alert-circle-exc',
      autoDismiss: 10
    };
    if (this.notificationAlertRef.current) {
      this.notificationAlertRef.current.notificationAlert(options);
    }
  };

  notifySuccess = (place, message) => {
    var type = 'success';
    var options = {
      place: place,
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: type,
      icon: 'tim-icons icon-check-2',
      autoDismiss: 7
    };
    if (this.notificationAlertRef.current) {
      this.notificationAlertRef.current.notificationAlert(options);
    }
  };

  expand = expandedItems => {
    this.setState({ expandedItems: expandedItems });
  };

  render() {
    return (
      <div
        className="content"
        // style={{width: "1500px"}}
      >
        <div className="rna-container">
          <NotificationAlert ref={this.notificationAlertRef} />
        </div>
        <div className="content">
          {this.props.role >= 200 && this.props.role < 230 && (
            <div style={{ marginRight: `35px` }}>
              <Button className="float-right" size="lg" id="create-shipment-btn" color="danger" onClick={this.toggle}>
                {this.state.showForm ? (
                  <div>
                    Create Delivery <i className="tim-icons icon-simple-delete" />
                  </div>
                ) : (
                  <div>
                    Create Delivery <i className="tim-icons icon-simple-add" />
                  </div>
                )}
              </Button>
              <Card className="card-form">
                <DropshipForm
                  errorDistance={this.state.errorDistance}
                  errorSubmit={this.state.errorSubmit}
                  handleErrorDistance={this.externalErrorDistance}
                  handleErrorSubmit={this.externalErrorSubmit}
                  showForm={this.state.showForm}
                  showForm2={this.state.showForm2}
                  savedDraftEdit={this.state.savedDraftEdit}
                  onSavedDraftEditClose={() => this.setState({ savedDraftEdit: null })}
                  handleForm={this.externalToggle}
                  notify={this.notify}
                  notifySuccess={this.notifySuccess}
                />
              </Card>
            </div>
          )}
          {this.props.role < 200 ? (
            <div>
              <Col style={{ flexDirection: `row`, marginRight: 20 }}>
                <DispatchOrderTable
                  role={this.props.role}
                  notify={this.notifySuccess}
                  notifyError={this.notify}
                  history={this.props.history}
                  expand={this.expand}
                  expandedItems={this.state.expandedItems}
                />
              </Col>
            </div>
          ) : (
            <div
            // style={{marginLeft: `-90px`}}
            >
              <Col>
                <CustomerPlanBanner />
                <MerchantOrderTable
                  role={this.props.role}
                  notify={this.notifySuccess}
                  history={this.props.history}
                  expand={this.expand}
                  expandedItems={this.state.expandedItems}
                  onEditSavedDraft={this.openSavedDraftEditor}
                />
              </Col>
              <BillChat />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Dashboard;
